import { render, staticRenderFns } from "./buscador-becario.vue?vue&type=template&id=77ce88e0&scoped=true&"
import script from "./buscador-becario.component.ts?vue&type=script&lang=ts&"
export * from "./buscador-becario.component.ts?vue&type=script&lang=ts&"
import style0 from "./buscador-becario.vue?vue&type=style&index=0&id=77ce88e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ce88e0",
  null
  
)

export default component.exports